export default __webpack_public_path__ + "static/InterDisplay-Italic-45f1cecc4f291910b88a5d6742ab4a84.woff2";